import React from 'react';

import {Button, CheckIcon, ModalPopup, Select} from '@kit';

import {useCharacter} from '../../../character-context';
import {choiceOptions} from '../../../model/choice-options';
import {useFeatureAction} from '../use-feature-action';
import type {ProcedureModalProps} from './procedure-modal-props';

import css from '../../sheet.module.css';

/** смена варианта особенности после отдыха: Добыча охотника, Оборонительная тактика */
export const ChangeChoiceModal: React.FC<ProcedureModalProps<'changeChoice'>> = ({action, onClose}) => {
	const {catalog, character, setChoice} = useCharacter();
	const {record} = useFeatureAction(action);
	const choices = character.choices.filter((choice) => choice.featureKey === action.featureKey);

	return (
		<ModalPopup open onClose={onClose} header={action.title} maxWidth={480}>
			{choices.length ? (
				<div className={css.formRows}>
					{choices.map((choice) => {
						const options = choiceOptions(choice, catalog, character);
						return (
							<div key={choice.key} className={css.formRow}>
								<span>{choice.group.label || action.title}</span>
								<Select
									items={options.map((option) => ({value: option.key, label: option.label}))}
									value={choice.selected[0] ?? null}
									onChange={([value]) => {
										if (!value || value === choice.selected[0]) return;
										setChoice(choice.key, [String(value)]);
										const label = options.find((option) => option.key === value)?.label;
										record(`выбрано: ${label || value}`);
									}}
								/>
							</div>
						);
					})}
				</div>
			) : (
				<p className={css.muted}>У особенности нет вариантов для замены.</p>
			)}
			<div className={css.modalButtons}>
				<Button appearance="primary" icon={<CheckIcon />} onClick={onClose}>
					Готово
				</Button>
			</div>
		</ModalPopup>
	);
};
